import React from 'react';
import * as PropTypes from 'prop-types';
import MenuTitle from './MenuTitle';
import { Loading } from '../Loading/Loading';
import {
  Button,
  Card,
  InputGroup,
  FormControl,
  Form as BSForm,
  ListGroup,
  Pagination,
  Badge,
} from 'react-bootstrap';
import { Formik, Form, Field } from 'formik';
import { faSync } from '@whitebox-learning/fontawesome-pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ShareConceptMenu = ({
  loadConcepts,
  toggleSharedConcept,
  back,
  close,
  loading,
  concepts,
  loadingList,
}) => {
  /* Get specifications options from the concepts */
  const specifications = concepts
    .map((c) => ({
      id: c.specificationId,
      name: c.specificationName,
    }))
    .filter((elem, i, arr) => arr.findIndex((s) => s.id === elem.id) === i)
    .sort((a, b) => (a.lastModified < b.lastModified ? 1 : -1));
  const [page, setPage] = React.useState(1);
  const [name, setName] = React.useState(null);
  const [spec, setSpec] = React.useState(null);
  const [filteredConcepts, setFilteredConcepts] = React.useState(concepts);
  const [selectedConcept, setSelectedConcept] = React.useState(null);
  React.useEffect(() => {
    setFilteredConcepts(
      concepts.filter(
        (c) =>
          (!name || c.name.toLowerCase().includes(name.toLowerCase())) &&
          (!spec || c.specificationId === parseInt(spec))
      )
    );
  }, [name, spec, concepts]);

  const conceptsPerPage = 8;
  const totalPages = Math.ceil((filteredConcepts.length - 1) / conceptsPerPage);

  const handleSetSelectedConcept = (conceptName) => {
    if (selectedConcept == conceptName) {
      setSelectedConcept(null);
      return;
    }
    setSelectedConcept(conceptName);
  };

  return (
    <div className="fm-simple-panel">
      {loading && <Loading />}
      <MenuTitle
        back={back}
        close={close}
        extraButtons={
          <Button
            variant="secondary"
            onClick={loadConcepts}
            title="Refresh Design List"
          >
            <FontAwesomeIcon icon={faSync} spin={loadingList} />
          </Button>
        }
      >
        Share
      </MenuTitle>
      <div className="fm-scroll">
        <h4>Share a Design</h4>

        <p className="mb-1">
          Sharing a design makes it available to be forked by all students in
          your group. When you unshare a design, designs that forked it remain
          available.
        </p>

        <div className="bg-light pt-1 p-2 mb-2 border border-rounded">
          <span className="fst-italic">Filter designs by:</span>
          <InputGroup className="my-1" size="sm">
            <InputGroup.Text id="filter-name">Concept Name:</InputGroup.Text>
            <FormControl
              placeholder="Any concept name"
              aria-label="Filter by name"
              aria-describedby="filter-name"
              onChange={(e) => setName(e.target.value || null)}
            />
          </InputGroup>

          <InputGroup className="mb-1" size="sm">
            <InputGroup.Text id="filter-spec">Specification:</InputGroup.Text>
            <BSForm.Select
              size="sm"
              defaultValue="-- All Specs --"
              aria-label="Filter by spec"
              aria-describedby="filter-spec"
              onChange={(e) => setSpec(e.target.value || null)}
            >
              <option value="">-- All Specs --</option>
              {specifications.map((s) => (
                <option value={s.id} key={s.id}>
                  {s.name}
                </option>
              ))}
            </BSForm.Select>
          </InputGroup>
        </div>

        {!filteredConcepts.length && (
          <p className="text-muted">No design concepts found.</p>
        )}

        <div className="mb-2">
          {filteredConcepts
            .slice((page - 1) * conceptsPerPage, page * conceptsPerPage)
            .map((c) => (
              <div
                key={c.name}
                onClick={() => handleSetSelectedConcept(c.name)}
                className="shared-design-row border rounded px-3 py-1"
              >
                <div className="d-flex justify-content-between">
                  <div>
                    <div className="concept-name" style={{ maxWidth: '300px' }}>
                      {c.name}
                    </div>
                    <div className="text-muted">
                      {c.specificationName} - {c.lastModified}
                    </div>
                  </div>
                  <div>
                    {c?.isShared ? (
                      <Badge bg="primary">Shared</Badge>
                    ) : (
                      <Badge bg="secondary">Not Shared</Badge>
                    )}
                  </div>
                </div>
                {selectedConcept == c.name && (
                  <>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="mt-2"
                      onClick={() => toggleSharedConcept(c.name, !c?.isShared)}
                    >
                      {c?.isShared ? 'Unshare' : 'Share'}
                    </Button>
                  </>
                )}
              </div>
            ))}
        </div>

        {totalPages > 1 && (
          <Pagination size="sm" className="m-0 my-2 justify-content-end">
            {[...Array(totalPages).keys()].map((index) =>
              ((i) => (
                <Pagination.Item
                  key={i}
                  active={i === page}
                  onClick={(e) =>
                    e.target.text && setPage(parseInt(e.target.text))
                  }
                >
                  {i}
                </Pagination.Item>
              ))(++index)
            )}
          </Pagination>
        )}
      </div>
    </div>
  );
};

export default ShareConceptMenu;
